import { NgModule } from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NetworkListComponent } from "@modules/+new/payments/shared-payments/components/network-list/network-list.component";
import { DepositSelectNetworkModalComponent } from "@modules/+new/payments/features/crypto-deposit/components/deposit-select-network-modal/deposit-select-network-modal.component";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { DepositWarningComponent } from "@modules/+new/payments/features/crypto-deposit/components/deposit-warning/deposit-warning.component";
import { CoreModule } from "@modules/core/core.module";
import { CryptoDepositSummaryTilesComponent } from "@modules/+new/payments/features/crypto-deposit/components/crypto-deposit-summary/crypto-deposit-summary-tiles/crypto-deposit-summary-tiles.component";
import { CryptoDepositSummaryComponent } from "@modules/+new/payments/features/crypto-deposit/components/crypto-deposit-summary/crypto-deposit-summary.component";
import { SummaryGridModule } from "@modules/+new/payments/shared-payments/components/summary-grid/summary-grid.module";
import { MultipleWalletsTrackingService } from "@main-services/wallet/multiple-wallets-tracking.service";
import { SelectCryptoWalletComponent } from "@modules/+new/payments/features/crypto-deposit/components/select-crypto-wallet/select-crypto-wallet.component";
import { SharedModule } from "@modules/+new/shared/shared.module";
import { FiatDepositModule } from "@modules/+new/payments/features/fiat-deposit/fiat-deposit.module";
import { DepositCryptoWalletComponent } from "./components/deposit-crypto-wallet/deposit-crypto-wallet.component";
import { DepositCryptoWalletDetailsComponent } from "./components/deposit-crypto-wallet/components/deposit-crypto-wallet-details/deposit-crypto-wallet-details.component";
import { FormatDepositLimitPipe } from "@modules/+new/payments/features/crypto-deposit/domain/infrastructure/format-deposit-limit.pipe";

@NgModule({
	declarations: [
		DepositSelectNetworkModalComponent,
		NetworkListComponent,
		DepositWarningComponent,
		CryptoDepositSummaryComponent,
		CryptoDepositSummaryTilesComponent,
		CryptoDepositSummaryTilesComponent,
		SelectCryptoWalletComponent,
		DepositCryptoWalletComponent,
		DepositCryptoWalletDetailsComponent,
		FormatDepositLimitPipe
	],
	imports: [
		TranslationPipeModule,
		UniversalModalModule,
		CommonModule,
		CoreModule,
		SummaryGridModule,
		SharedModule,
		FiatDepositModule,
		NgOptimizedImage
	],
	exports: [NetworkListComponent],
	providers: [MultipleWalletsTrackingService]
})
export class CryptoDepositModule {}
